/*
 * @Description:
 * @Date: 2024-11-29 11:37:12
 */
import appStore from '@/store';
import { storeToRefs } from 'pinia';
import router from '@/router';
import { LOGIN_PAGE_PATH } from '@constants/system';
import { TOKEN_KEY } from '@/config';

export default async (to, next) => {
  const { info: userInfo } = storeToRefs(appStore.useUserStoreSetup);
  // 进入登录页
  if (!userInfo.value[TOKEN_KEY] && to.path === LOGIN_PAGE_PATH) {
    next();
    return Promise.reject();
  }

  if (!userInfo.value[TOKEN_KEY]) {
    // 跳转主项目login页面
    next({
      path: LOGIN_PAGE_PATH,
      query: { redirect: router.currentRoute.value.fullPath }
    });
    return Promise.reject();
  }
  return Promise.resolve();
};
